import PropTypes from 'prop-types';
import React from 'react';
import MetaTags from '../MetaTags';

const GeonameMapPageMeta = ({ name, urlPath }) => (
  <MetaTags
    title={`${name} Surf Report & Forecast - Map of ${name} Surf Spots & Cams - Surfline`}
    description="The most accurate and trusted surf reports, forecasts, and coastal weather. Surfers from around the world choose Surfline for dependable and up to date surfing forecasts and high quality surf content, live surf cams, and features."
    urlPath={urlPath}
  />
);

GeonameMapPageMeta.propTypes = {
  name: PropTypes.string.isRequired,
  urlPath: PropTypes.string.isRequired,
};

export default GeonameMapPageMeta;
